import React from "react";
import "./KitColors.css";

/** Keep up to 3 valid #RRGGBB colors. */
export function normalizeKitColors(raw) {
  if (!Array.isArray(raw)) return [];
  return raw
    .map((c) => (typeof c === "string" ? c.trim() : ""))
    .filter((c) => /^#[0-9A-Fa-f]{6}$/i.test(c))
    .map((c) => c.toUpperCase())
    .slice(0, 3);
}

export function kitColorsConicGradient(colors) {
  const list = normalizeKitColors(colors);
  if (list.length === 0) return null;
  if (list.length === 1) return list[0];
  const slice = 100 / list.length;
  // Vertical bands (stripes run top→bottom).
  const stops = list
    .map((color, i) => {
      const start = (i * slice).toFixed(2);
      const end = ((i + 1) * slice).toFixed(2);
      return `${color} ${start}% ${end}%`;
    })
    .join(", ");
  return `linear-gradient(to right, ${stops})`;
}

export function KitColorSwatches({ colors, emptyLabel = null, size = 18 }) {
  const list = normalizeKitColors(colors);
  if (list.length === 0) {
    return emptyLabel ? (
      <span className="kit-colors-empty">{emptyLabel}</span>
    ) : null;
  }
  const fill = kitColorsConicGradient(list);
  return (
    <span
      className="kit-color-swatch kit-color-swatch--composed"
      style={{
        width: size,
        height: size,
        background: fill,
      }}
      title={list.join(" · ")}
      aria-label={`Colores: ${list.join(", ")}`}
    />
  );
}

/**
 * Edit up to 3 kit colors with color pickers.
 */
const KitColorsEditor = ({ label, colors, onChange, helpText, disabled }) => {
  const list = Array.isArray(colors) ? colors.slice(0, 3) : [];

  const setAt = (index, value) => {
    const next = [...list];
    next[index] = value;
    onChange(normalizeKitColors(next));
  };

  const addColor = () => {
    if (list.length >= 3 || disabled) return;
    onChange(normalizeKitColors([...list, "#FFFFFF"]));
  };

  const removeAt = (index) => {
    if (disabled) return;
    onChange(normalizeKitColors(list.filter((_, i) => i !== index)));
  };

  return (
    <div className="kit-colors-editor">
      <div className="kit-colors-editor-head">
        <span className="reg-label">{label}</span>
      </div>
      {helpText && <span className="reg-hint">{helpText}</span>}
      {list.length === 0 ? (
        <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
          <span className="kit-colors-empty">Sin colores</span>
          <button
            type="button"
            className="kit-colors-add"
            onClick={addColor}
            disabled={disabled}
          >
            + Agregar
          </button>
        </div>
      ) : (
        <div className="kit-color-rows">
          {list.map((color, index) => (
            <div key={index} className="kit-color-row">
              <input
                type="color"
                value={/^#[0-9A-Fa-f]{6}$/i.test(color) ? color : "#FFFFFF"}
                onChange={(e) => setAt(index, e.target.value)}
                title={`Color ${index + 1}`}
                disabled={disabled}
                className="kit-color-picker"
              />
              <button
                type="button"
                className="kit-color-remove"
                onClick={() => removeAt(index)}
                disabled={disabled}
                aria-label="Quitar color"
              >
                ×
              </button>
            </div>
          ))}
          {list.length < 3 && (
            <button
              type="button"
              className="kit-colors-add"
              onClick={addColor}
              disabled={disabled}
            >
              + Agregar
            </button>
          )}
        </div>
      )}
    </div>
  );
};

export default KitColorsEditor;
